import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import IssuerType from "../../../Models/Catalogue/General/IssuerType";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { Catalogue } from "@singularsystems/neo-react-services";

export default class IssuerTypeCatalogueEntry extends CatalogueEntry<IssuerType> {

    constructor() {
        super("Issuer Types", IssuerType);
    }

    public get editRole() {
        return CatalogueRoles.IssuerTypes.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.issuerTypes;
    }
    
    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveIssuerTypes;
    }
    
    public renderRow(item: IssuerType, meta: Model.TransformMetaType<IssuerType>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.issuerTypeName} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}